import { AllocationViewActionIdentifierModel, AllocationViewFinishDepartureSecurityModel } from '../../models';

export class AllocationViewFinishDepartureSecurityAction {
  public static readonly type = '[AllocationViewFinishDepartureSecurityAction] Finish Departure Security';

  constructor(public data: AllocationViewFinishDepartureSecurityModel) {}
}

export class AllocationViewFinishDepartureSecurityActionPrepare {
  public static readonly type = '[AllocationViewFinishDepartureSecurityAction] Finish Departure Security Prepare';

  constructor(public identifier: AllocationViewActionIdentifierModel, public language: string) {}
}

export class AllocationViewFinishDepartureSecurityActionSetInitialState {
  public static readonly type = '[AllocationViewFinishDepartureSecurityAction] Set Initial State';
}
